/* unplugin-vue-components disabled */import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef } from "vue";
const _hoisted_1 = {
  style: {
    "display": "inline-block",
    "margin-bottom": "0.4rem",
    "margin-left": "55rem"
  }
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1,
  style: {
    "color": "red"
  }
};
import { addFieldTemplate, deleteField, getFieldTemplate, queryOption } from '@/api/base/fieldTemplate';
import { VueDraggable } from 'vue-draggable-plus';
export default {
  __name: 'editfield',
  setup(__props, {
    expose: __expose
  }) {
    const route = useRoute();
    const {
      proxy
    } = getCurrentInstance();
    const visible = ref(false);
    const field = ref(null);
    const btnName = ref("新增字段");
    const btnType = ref("primary");
    const open = ref(false);
    const title = ref(null);
    const deviceType = ref(null);
    const fieldType = ref([{
      label: '字符',
      value: 1
    }, {
      label: 'boolean类型',
      value: 2
    }, {
      label: '日期时间类型',
      value: 3
    }, {
      label: '数字类型',
      value: 4
    }, {
      label: '单选类型',
      value: 5
    }, {
      label: '多选类型',
      value: 6
    }]);
    const data = reactive({
      form: {
        fieldTemplateList: [],
        type: null,
        option: {},
        map: {
          label: null,
          value: null
        }
      },
      rules: {
        label: [{
          required: true,
          message: '选项名不能为空',
          trigger: 'blur'
        }],
        value: [{
          required: true,
          message: '选项值不能为空',
          trigger: 'blur'
        }]
      }
    });
    const {
      form,
      rules
    } = toRefs(data);

    // 显示弹框
    function show(type) {
      deviceType.value = type;
      getList();
    }
    function getList() {
      getFieldTemplate(deviceType.value).then(res => {
        form.value.fieldTemplateList = res.data;
        if (form.value.fieldTemplateList.length <= 0) {
          form.value.fieldTemplateList.push({
            field: '',
            label: '',
            type: 1,
            required: false,
            del: true
          });
          btnName.value = '保存';
          btnType.value = 'success';
        }
        visible.value = true;
      });
    }
    function addField() {
      if (btnName.value === '新增字段') {
        form.value.fieldTemplateList.push({
          field: '',
          label: '',
          type: 1,
          required: false,
          del: true
        });
        btnName.value = '保存';
        btnType.value = 'success';
      } else {
        for (let i = 0; i < form.value.fieldTemplateList.length; i++) {
          let fieldData = form.value.fieldTemplateList[i];
          if (fieldData.field.length <= 0 || fieldData.field.length > 40) {
            proxy.$modal.msgError('请确保每个字段名长度大于0小于或等于40');
            return;
          }
          if (fieldData.label.length <= 0 || fieldData.label.length > 40) {
            proxy.$modal.msgError('请确保每个显示名长度大于0小于或等于40');
            return;
          }
        }
        form.value.type = deviceType.value;
        addFieldTemplate(form.value).then(res => {
          proxy.$modal.msgSuccess(res.msg);
          btnName.value = '新增字段';
          btnType.value = 'primary';
          getList();
        });
      }
    }
    function saveSort() {
      form.value.type = deviceType.value;
      addFieldTemplate(form.value).then(res => {
        proxy.$modal.msgSuccess(res.msg);
        getList();
      });
    }
    function editOption(fieldname) {
      queryOption(fieldname, deviceType.value).then(res => {
        field.value = fieldname;
        form.value.option = res.data;
        open.value = true;
        title.value = '编辑选项';
      });
    }
    function edit() {
      btnName.value = '保存';
      btnType.value = 'success';
    }
    function close() {
      btnName.value = "新增字段";
      btnType.value = 'primary';
      deviceType.value = undefined;
      visible.value = false;
    }
    function deleteCurField(field) {
      proxy.$modal.confirm("此操作将永久删除该字段,并且使用该字段的数据也将删除, 是否继续?").then(function () {
        if (field === undefined || field === null) {
          proxy.$modal.msgError('字段名为空无法删除');
          return;
        }
        deleteField(field, deviceType.value).then(() => {
          proxy.$modal.msgSuccess('删除成功');
          getFieldTemplate(deviceType.value).then(res => {
            form.value.fieldTemplateList = res.data;
          });
        });
      }).catch(() => {
        proxy.$modal.msg('已取消删除');
      });
    }
    //添加选项方法
    function addOption() {
      proxy.$refs["optionRef"].validate(valid => {
        if (valid) {
          for (let i = 0; i < form.value.fieldTemplateList.length; i++) {
            if (form.value.fieldTemplateList[i].field === field.value) {
              if (form.value.fieldTemplateList[i].map === null || form.value.fieldTemplateList[i].map === undefined) {
                form.value.fieldTemplateList[i].map = [];
              }
              for (let j = 0; j < form.value.fieldTemplateList[i].map.length; j++) {
                if (form.value.fieldTemplateList[i].map[j].label === form.value.map.label) {
                  proxy.$modal.msgError("存在重复选项名，无法添加");
                  return;
                }
                if (form.value.fieldTemplateList[i].map[j].value.toString() === form.value.map.value.toString()) {
                  proxy.$modal.msgError("存在重复选项值，无法添加");
                  return;
                }
              }
              form.value.fieldTemplateList[i].map.push({
                label: form.value.map.label,
                value: form.value.map.value
              });
              form.value.type = deviceType.value;
              addFieldTemplate(form.value).then(() => {
                queryOption(field.value, deviceType.value).then(res => {
                  form.value.option = res.data;
                });
                proxy.$modal.msgSuccess("保存成功");
                btnName.value = '新增字段';
                btnType.value = 'primary';
                form.value.map.label = '';
                form.value.map.value = '';
              });
            }
          }
        }
      });
    }
    //删除选项方法
    function delOption(label) {
      proxy.$modal.confirm("此操作将永久删除该选项, 是否继续?").then(function () {
        for (let i = 0; i < form.value.fieldTemplateList.length; i++) {
          if (form.value.fieldTemplateList[i].field === field.value) {
            for (let j = 0; j < form.value.fieldTemplateList[i].map.length; j++) {
              if (form.value.fieldTemplateList[i].map[j].label === label) {
                form.value.fieldTemplateList[i].map.splice(j, 1);
                form.value.type = deviceType.value;
                addFieldTemplate(form.value).then(() => {
                  proxy.$modal.msgSuccess("删除成功");
                  queryOption(field.value, deviceType.value).then(res => {
                    form.value.option = res.data;
                  });
                });
              }
            }
          }
        }
      }).catch(() => {
        proxy.$modal.msg('已取消删除');
      });
    }
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_Operation = _resolveComponent("Operation");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        title: "自定义字段",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "120rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        "show-close": false,
        draggable: ""
      }, {
        default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("div", {
          style: {
            "display": "inline-block"
          }
        }, [_createElementVNode("h3", {
          style: {
            "color": "red"
          }
        }, [_createTextVNode("字段名添加后无法修改，请谨慎操作"), _createElementVNode("span", {
          style: {
            "color": "#13ce66"
          }
        }, "(点击选中某一行拖拽可实现排序)")])], -1)), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          class: "satpro-button",
          onClick: saveSort
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("保存排序", -1)]))]),
          _: 1
        })]), _createVNode(_component_el_card, {
          class: "card-box"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            ref: "formRef",
            model: _unref(form),
            rules: _unref(rules),
            "label-width": "10rem"
          }, {
            default: _withCtx(() => [_createVNode(_unref(VueDraggable), {
              modelValue: _unref(form).fieldTemplateList,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).fieldTemplateList = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).fieldTemplateList, (item, key) => {
                return _openBlock(), _createBlock(_component_el_row, {
                  key: key
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 2
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [_createVNode(_component_el_icon, {
                        style: {
                          "margin-top": "0.8rem",
                          "cursor": "pointer"
                        }
                      }, {
                        default: _withCtx(() => [_createVNode(_component_Operation)]),
                        _: 1
                      })]),
                      _: 1
                    })]),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 6
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "字段名"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        minlength: 1,
                        disabled: !item.del,
                        maxlength: 40,
                        placeholder: "请输入内容",
                        modelValue: item.field,
                        "onUpdate:modelValue": $event => item.field = $event,
                        onChange: edit
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1024), _createVNode(_component_el_col, {
                    span: 5
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "显示名"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_input, {
                        minlength: 1,
                        maxlength: 40,
                        placeholder: "请输入显示名",
                        modelValue: item.label,
                        "onUpdate:modelValue": $event => item.label = $event,
                        onChange: edit
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1024), _createVNode(_component_el_col, {
                    span: 4
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, {
                      label: "字段类型"
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_select, {
                        placeholder: "请选择字段类型",
                        onChange: edit,
                        modelValue: item.type,
                        "onUpdate:modelValue": $event => item.type = $event,
                        filterable: "",
                        style: {
                          "width": "20rem"
                        }
                      }, {
                        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fieldType), item => {
                          return _openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]);
                        }), 128))]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1024), _createVNode(_component_el_col, {
                    span: 2
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                        modelValue: item.required,
                        "onUpdate:modelValue": $event => item.required = $event,
                        onChange: edit
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("必填", -1)]))]),
                        _: 1
                      }, 8, ["modelValue", "onUpdate:modelValue"])]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1024), _createVNode(_component_el_col, {
                    span: 5
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                        class: "satpro-button",
                        size: "mini",
                        onClick: $event => editOption(item.field)
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("编辑/查看选项", -1)]))]),
                        _: 1
                      }, 8, ["onClick"]), [[_vShow, item.type === 5 || item.type === 6]]), !item.del ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "satpro-button",
                        size: "mini",
                        onClick: $event => deleteCurField(item.field)
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("删除", -1)]))]),
                        _: 1
                      }, 8, ["onClick"])) : _createCommentVNode("", true)]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["model", "rules"])]),
          _: 1
        }), _createVNode(_component_el_form, {
          style: {
            "padding-top": "1.5rem"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            style: {
              "padding-left": "35rem"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  type: _unref(btnType),
                  class: "satpro-button",
                  onClick: addField
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(btnName)), 1)]),
                  _: 1
                }, 8, ["type"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  class: "satpro-button",
                  onClick: close
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("返回", -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modal: true,
        title: _unref(title),
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(open) ? open.value = $event : null),
        width: "80rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        draggable: ""
      }, {
        default: _withCtx(() => [_unref(form).option && _unref(form).option.length > 0 ? (_openBlock(), _createElementBlock("b", _hoisted_2, "选项名(悬浮显示选项值)：")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).option, (item, i) => {
          return _openBlock(), _createElementBlock("span", {
            key: i,
            style: {
              "margin": "0.3rem"
            }
          }, [_createVNode(_component_el_tooltip, {
            content: item.value,
            placement: "top",
            "auto-close": 500
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: $event => delOption(item.label)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1032, ["content"])]);
        }), 128)), _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)), _unref(form).option && _unref(form).option.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(单击选项名删除选项)")) : _createCommentVNode("", true), _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1)), _createVNode(_component_el_form, {
          ref: "optionRef",
          model: _unref(form).map,
          rules: _unref(rules),
          "label-width": "10rem"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "选项名",
                prop: "label"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  placeholder: "选项名",
                  modelValue: _unref(form).map.label,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).map.label = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "选项值",
                prop: "value"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  placeholder: "选项值",
                  modelValue: _unref(form).map.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).map.value = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  class: "satpro-button",
                  size: "mini",
                  onClick: addOption
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("确 定", -1)]))]),
                  _: 1
                }), _createVNode(_component_el_button, {
                  class: "satpro-button",
                  size: "mini",
                  onClick: _cache[4] || (_cache[4] = $event => open.value = false)
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("取 消", -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["title", "modelValue"])], 64);
    };
  }
};